module.exports = __webpack_public_path__ + "img/sell.4015d93e.png";